import React, { Component } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import './styles.scss';
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';
import WorkingHourForm from '../../components/WorkingHourForm';
import moment from 'moment';
import {
    getWorklogList,
    addWorklog,
    updateWorklog,
    deleteWorklog,
    getApproval
} from '../../core/actions/workingHourAction';
import ProjectTable from '../../components/ProjectTable';
import functionCommon from '../../core/common/function';
import CONSTANT from '../../core/constant/constant';
class WorkingHour extends Component {

    constructor(props) {
        super(props);        
        this.state = {
            paramList: {
                date: new Date().toISOString().split("T")[0],
                sortBy: 'createdDate-DESC',
                projectBy: 'projectCode-ASC',
                employeeId: functionCommon.getInfoUser('employeeId'),
                approverSort: 'lastName-ASC'
            },
            tableStructure: [
                {
                    label: 'labels.id',
                    type: 'id',
                    isClass: 'example-class'
                },
                {
                    label: 'labels.workingHour',
                    type: 'normalTime',
                    isClass: 'normal-time-col'
                },
                {
                    label: 'labels.overtimeType',
                    type: 'overtimeType',
                    subType: 'overtimeList',
                    isValueInArray: true,
                    isChangeText: true,
                    arrayTextChange: {
                        '0': 'overtimeType.0',
                        '1': 'overtimeType.1',
                        '2': 'overtimeType.2',
                        '3': 'overtimeType.3',
                        '4': 'overtimeType.4',
                        '5': 'overtimeType.5',
                        '6': 'overtimeType.6',
                        '7': 'overtimeType.7'
                    },
                    isClass: 'overtime-type-col'
                },
                {
                    label: 'labels.overtime',
                    type: 'overtimeHour',
                    subType: 'overtimeList',
                    isValueInArray: true,
                    isClass: 'overtime-col'
                },
                {
                    label: 'labels.projectCode',
                    type: 'projectCode'
                },
                {
                    label: 'labels.projectName',
                    type: 'projectName'
                },
                {
                    label: 'labels.shift',
                    type: 'shift',
                    isChangeText: true,
                    arrayTextChange: {
                        '0': 'shift.0',
                        '1': 'shift.1',
                        '2': 'shift.2'
                    }
                },
                {
                    label: 'labels.approver',
                    type: 'approverId',
                    isChangeText: true,
                    arrayTextChange: {}
                },
                {
                    label: 'labels.status',
                    type: 'status',
                    isChangeText: true,
                    arrayTextChange: {
                        '0': 'labels.waiting',
                        '1': 'labels.submitted',
                        '2': 'labels.approved',
                        '3': 'labels.rejected'
                    }
                },
                {
                    label: 'labels.remark',
                    type: 'remark',
                    isClass: 'remark-col'
                }
            ],
            worklog: {
                id: 1,
                projectId: '',
                projectCode: '',
                projectName: '',
                businessFrom: '',
                businessTo: '',
                normalTime: '',
                'overtime-1': '',
                'overtimeType-1': '',
                'overtime-2': '',
                'overtimeType-2': '',
                'overtime-3': '',
                'overtimeType-3': '',
                remark: '',
                site: '',
                shift: '',
                status: '',
                approverId: ''
            },
            dataProject: [],
            dataApprover: [],
            employeeArr: {},
            totalOtDay: '',
            totalOtOfMonth: '',
            totalWorkingHourDay: '',
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
            data: '',
            disabled: false,
            btnDisable: false,
            unSelectRow: false,
            errorCode: '',
            successCode: '',
            isSearch: 1,
            rowId: '',
            isTotal: false,
            isAdded: false,
            isWaiting: true,
            noData: '',
            hasWorklog: '',
            isSpecialProject: '',
            hasApprover: 0
        }
    }

    componentWillMount() {
        this.props.getWorklogList(this.state.paramList); 
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.workingHourReducer.isLoading) {
            this.clearWorklog();
            if (this.state.isAdded === true) {
                this.getList();
            } else {
                this.props.getWorklogList(this.state.paramList);
            }
        } else {
            let data = [];
            if (nextProps.workingHourReducer.dataWorkingHour.workLog) {                
                data = nextProps.workingHourReducer.dataWorkingHour.workLog.map((item, i) => {
                    return {
                        ...item,
                        id: (item.id) ? item.id : 'def-'+i,
                        normalTime: (item.normalTime) ? item.normalTime : '',
                        businessFrom: (item.businessFrom) ? item.businessFrom : null,
                        businessTo: (item.businessTo) ? item.businessTo : null,
                        overtime: (item.overtime) ? item.overtime : '',
                        overtimeType: (item.overtimeType) ? item.overtimeType : null,
                        remark: (item.remark) ? item.remark : '',
                        shift: (item.shift) ? item.shift : null,
                        site: (item.site) ? item.site : 0,
                        status: (item.status) ? item.status : null,
                        approverId: (item.approverId) ? item.approverId : null
                    };
                });
            }
            let dataProject = nextProps.workingHourReducer.dataWorkingHour.projectCombobox;
            let dataApprover = nextProps.workingHourReducer.dataWorkingHour.employee || [];
            let totalOtDay = nextProps.workingHourReducer.dataWorkingHour.totalOtDay;
            let totalOtOfMonth = nextProps.workingHourReducer.dataWorkingHour.totalOtOfMonth;
            let totalWorkingHourDay = nextProps.workingHourReducer.dataWorkingHour.totalWorkingHourDay;
            let checkStatus = nextProps.workingHourReducer.dataWorkingHour.checkStatus;
            let hasWorklog = (nextProps.workingHourReducer.dataWorkingHour.workLog !== "" 
                            && this.isKeyInObject(nextProps.workingHourReducer.dataWorkingHour.workLog)) ? 1 : 0

            let hasApprover = this.hasApprover(nextProps.workingHourReducer.dataWorkingHour.workLog) ? 1 : 0;

            let employeeArr = dataApprover.reduce(function(r, e) {
                r[e.id] = e.employeeName;
                return r;
            }, {});

            let employeeArrCopy = JSON.parse(JSON.stringify(this.state.tableStructure));
            employeeArrCopy[7].arrayTextChange = employeeArr;
            this.setState({
                data: data,
                dataProject: dataProject,
                dataApprover: dataApprover,
                tableStructure: employeeArrCopy,
                totalOtDay: totalOtDay,
                totalOtOfMonth: totalOtOfMonth,
                totalWorkingHourDay: totalWorkingHourDay,
                btnDisable: false,
                isWaiting: (checkStatus === 0) ? false : true,
                hasWorklog: hasWorklog,
                hasApprover: hasApprover
            });

            // No data
            if (!data || data && !data[0]) {
                this.setState({
                    errorCode: '018',
                    isTotal: false
                });
                setTimeout(
                    function () {
                        this.setState({ errorCode: '' });
                    }
                        .bind(this),
                    2000
                );
            } else {
                this.setState({
                    errorCode: '',
                    isTotal: true
                });
            }

            if (nextProps.workingHourReducer.successCode) {
                this.setState({
                    successCode: nextProps.workingHourReducer.successCode,
                });
                if (this.state.isAdded === true) {
                    this.clearParamList(false);
                }
                setTimeout(
                    function () {
                        this.setState({ successCode: "" });
                        nextProps.workingHourReducer.successCode = ""
                    }.bind(this),
                    2000
                );
            }

            if (nextProps.workingHourReducer.errorCode) {
                this.setState({
                    errorCode: nextProps.workingHourReducer.errorCode,
                });
                setTimeout(
                    function () {
                        this.setState({ errorCode: "" });
                        nextProps.workingHourReducer.errorCode = "";
                    }.bind(this),
                    2000
                );
            }
        }
    }

    isKeyInObject = (arr) => {
        return arr && arr.some(function(el) {
            return el.id !== undefined;
        }); 
    }

    hasApprover = (arr) => {
        return arr && arr.some(function(el) {
            return el.approverId;
        }); 
    }

    async getList() {
        let clrParam = await this.clearParamList(false);
        return this.props.getWorklogList(this.state.paramList);       
    }

    // Search Worklog
    async searchWorklog(date) {
        this.clearError();
        this.setState({ btnDisable: true });
        this.clearWorklog();
        
        const searchParam = {
            date: date,
            sortBy: this.state.paramList.sortBy,
            projectBy: this.state.paramList.projectBy,
            employeeId: this.state.paramList.employeeId,
            approverSort: this.state.paramList.approverSort
        };

        await this.setState({
            paramList: searchParam,
            disabled: false,
            unSelectRow: false
        })

        return this.props.getWorklogList(searchParam);
    }

    // Event when click btn Add
    addWorklog = () => {
        if (!this.checkValidate()) return;
        this.setState({ btnDisable: true });
        const employeeId = this.state.paramList.employeeId;
        const projectId = this.state.worklog.projectId;
        const normalTime = (this.state.worklog.normalTime) 
                            ? Number(this.state.worklog.normalTime.replace(',','.')).toFixed(2) : '';
        const ot1 = (this.state.worklog['overtime-1']) && (functionCommon.isDecimal(this.state.worklog['overtime-1']))
                    ? Number(this.state.worklog['overtime-1'].replace(',','.')).toFixed(2) : this.state.worklog['overtime-1'].replace(',','.');
        const otType1 = this.state.worklog['overtimeType-1'];
        const ot2 = (this.state.worklog['overtime-2']) && (functionCommon.isDecimal(this.state.worklog['overtime-2']))
                    ? Number(this.state.worklog['overtime-2'].replace(',','.')).toFixed(2) : this.state.worklog['overtime-2'].replace(',','.');
        const otType2 = this.state.worklog['overtimeType-2'];
        const ot3 = (this.state.worklog['overtime-3']) && (functionCommon.isDecimal(this.state.worklog['overtime-3']))
                    ? Number(this.state.worklog['overtime-3'].replace(',','.')).toFixed(2) : this.state.worklog['overtime-3'].replace(',','.');
        const otType3 = this.state.worklog['overtimeType-3'];
        const date = this.state.paramList.date;
        const remark = this.state.worklog.remark;
        const businessFrom = this.state.worklog.businessFrom 
                            ? moment(this.state.worklog.businessFrom, "HHmm").format("HH-mm") : "";
        const businessTo = this.state.worklog.businessTo 
                            ? moment(this.state.worklog.businessTo, "HHmm").format("HH-mm") : "";
        const site = this.state.worklog.site === true ? 1 : 0;
        const shift = this.state.worklog.shift;
        const approverId = this.state.worklog.approverId;
        const overtimeList = [(ot1 !== '') ? otType1 + '-' + ot1 : '', 
                        (ot2 !== '') ? otType2 + '-' + ot2 : '', 
                        (ot3 !== '') ? otType3 + '-' + ot3 : '']
        this.setState({ isAdded: true });
        return this.props.addWorklog({
            employeeId: employeeId,
            projectId: projectId,
            normalTime: normalTime,
            date: date,
            remark: remark,
            businessFrom: businessFrom,
            businessTo: businessTo,
            site: site,
            shift: shift,
            approverId: approverId,
            overtimeList: overtimeList.filter(Boolean).join(','),
            status: ''
        });
    }

    // Event when click btn Update
    updateWorklog = () => {
        if (!this.checkValidate()) return;
        this.setState({ btnDisable: true });
        const id = this.state.rowId;
        const employeeId = this.state.paramList.employeeId;
        const projectId = this.state.worklog.projectId;
        const normalTime = (this.state.worklog.normalTime) 
                            ? Number(this.state.worklog.normalTime.replace(',','.')).toFixed(2) : '';
        const ot1 = (this.state.worklog['overtime-1']) && (functionCommon.isDecimal(this.state.worklog['overtime-1']))
                    ? Number(this.state.worklog['overtime-1'].replace(',','.')).toFixed(2) : this.state.worklog['overtime-1'].replace(',','.');
        const otType1 = this.state.worklog['overtimeType-1'];
        const ot2 = (this.state.worklog['overtime-2']) && (functionCommon.isDecimal(this.state.worklog['overtime-2']))
                    ? Number(this.state.worklog['overtime-2'].replace(',','.')).toFixed(2) : this.state.worklog['overtime-2'].replace(',','.');
        const otType2 = this.state.worklog['overtimeType-2'];
        const ot3 = (this.state.worklog['overtime-3']) && (functionCommon.isDecimal(this.state.worklog['overtime-3']))
                    ? Number(this.state.worklog['overtime-3'].replace(',','.')).toFixed(2) : this.state.worklog['overtime-3'].replace(',','.');
        const otType3 = this.state.worklog['overtimeType-3'];
        const date = this.state.paramList.date;
        const remark = this.state.worklog.remark;
        const businessFrom = this.state.worklog.businessFrom 
                            ? moment(this.state.worklog.businessFrom, "HHmm").format("HH-mm") : "";
        const businessTo = this.state.worklog.businessTo 
                            ? moment(this.state.worklog.businessTo, "HHmm").format("HH-mm") : "";
        const site = this.state.worklog.site === true ? 1 : 0;
        const shift = this.state.worklog.shift;
        const approverId = this.state.worklog.approverId;
        const overtimeList = [(ot1 !== '') ? otType1 + '-' + ot1 : '', 
                        (ot2 !== '') ? otType2 + '-' + ot2 : '', 
                        (ot3 !== '') ? otType3 + '-' + ot3 : '']
        this.setState({ isAdded: false });

        return this.props.updateWorklog({
            id: id,
            employeeId: employeeId,
            projectId: projectId,
            normalTime: normalTime,
            date: date,
            remark: remark,
            businessFrom: businessFrom,
            businessTo: businessTo,
            site: site,
            shift: shift,
            approverId: approverId,
            overtimeList: overtimeList.filter(Boolean).join(','),
            status: ''
        });
    }

    // Delete worklog
    deleteWorklog = async () => {
        this.setState({ btnDisable: true });
        const id = this.state.rowId;
        this.clearWorklog();

        if (this.state.data.length === 1) {
            this.setState(prevState => ({
                paramList: {
                    ...prevState.paramList
                }
            }));
        }
        this.setState({ isAdded: false });
        return this.props.deleteWorklog({ id: id });
    }

    // getApproval worklog
    getApproval = async () => {    
        if (this.state.hasApprover === 0) {
            this.setState({
                errorCode: "602"
            });
            setTimeout(function(){
                this.setState({
                    errorCode: ""
                });
            }.bind(this), 2000)
        } else {
            let approverId = "";
            this.state.data.some(function(el) {
                if (el.approverId !== null) {
                    approverId = el.approverId
                }
            });
            return this.props.getApproval({ 
                employeeId: functionCommon.getInfoUser('employeeId'),
                date: this.state.paramList.date,
                approverId: approverId
            });
        }        
    }

    // Clear Worklog
    clearWorklog = () => {
        this.setState({
            worklog: {
                id: 1,
                projectId: '',
                projectCode: '',
                projectName: '',
                businessFrom: '',
                businessTo: '',
                normalTime: '',
                'overtime-1': '',
                'overtimeType-1': '',
                'overtime-2': '',
                'overtimeType-2': '',
                'overtime-3': '',
                'overtimeType-3': '',
                remark: '',
                site: '',
                shift: '',
                status: '',
                approverId: ''
            },
            disabled: false,
            unSelectRow: false,
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
            isSpecialProject: ''
        })
    }

    // Clear input error text
    clearError = () => {
        this.setState({
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
        });
    }
    
    // Clear param list call API
    clearParamList = (isSort) => {
        this.setState({
            paramList: {
                date: this.state.paramList.date,                
                sortBy: (isSort !== true) ? "createdDate-DESC" : this.state.paramList.sortBy,
                projectBy: 'projectCode-ASC',
                employeeId: functionCommon.getInfoUser('employeeId'),
                approverSort: this.state.paramList.approverSort
            },
        });
    }

    // Handle on change input
    changeWorkLog = evt => {
        const name = evt.target.name;
        const value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
        this.setState(prevState => ({
            worklog: {
                ...prevState.worklog,
                [name]: value
            }
        }));
        this.setState(prevState => ({
            inputSubmit: {
                ...prevState.inputSubmit,
                formError: {
                    ...prevState.inputSubmit.formError,
                    [name]: ''
                }
            }
        }));
    }

    // Handle change business time input
    changeBusinessTime = (name, value) => {
        this.setState(prevState => ({
            worklog: {
                ...prevState.worklog,
                [name]: value
            }
        }));
        this.setState(prevState => ({
            inputSubmit: {
                ...prevState.inputSubmit,
                formError: {
                    ...prevState.inputSubmit.formError,
                    [name]: ''
                }
            }
        }));
    }

    // Select worklog on Click
    onRowClick = (val) => {
        this.clearError();
        let _worklog = {
            id: (val.id !== null) ? val.id : '',
            projectId: (val.projectId !== null) && this.checkProjectId(val.projectCode) ? val.projectId : '',
            projectCode: (val.projectCode !== null) ? val.projectCode : '',
            projectName: (val.projectName !== null) ? val.projectName : '',
            businessFrom: (val.businessFrom !== null) ? val.businessFrom : '',
            businessTo: (val.businessTo !== null) ? val.businessTo : '',
            normalTime: (val.normalTime !== null) ? val.normalTime : '',
            'overtime-1': (val.overtimeList && val.overtimeList[0] && val.overtimeList[0].overtimeHour !== null) ? val.overtimeList[0].overtimeHour : '',
            'overtimeType-1': (val.overtimeList && val.overtimeList[0] && val.overtimeList[0].overtimeType !== null) ? val.overtimeList[0].overtimeType : '',
            'overtime-2': (val.overtimeList && val.overtimeList[1] && val.overtimeList[1].overtimeHour !== null) ? val.overtimeList[1].overtimeHour : '',
            'overtimeType-2': (val.overtimeList && val.overtimeList[1] && val.overtimeList[1].overtimeType !== null) ? val.overtimeList[1].overtimeType : '',
            'overtime-3': (val.overtimeList && val.overtimeList[2] && val.overtimeList[2].overtimeHour !== null) ? val.overtimeList[2].overtimeHour : '',
            'overtimeType-3': (val.overtimeList && val.overtimeList[2] && val.overtimeList[2].overtimeType !== null) ? val.overtimeList[2].overtimeType : '',
            remark: (val.remark !== null) ? val.remark : '',
            site: val.site === "1" ? true : false,
            shift: (val.shift !== null) ? val.shift : '',
            status: (val.status !== null) ? val.status : '',
            approverId: (val.approverId !== null) ? val.approverId : ''
        };

        let disableCondition = '';
        if ((val.id.indexOf('def') !== -1) && this.checkProjectId(val.projectCode)) {
            disableCondition = false;
        } else if ((val.id.indexOf('def') === -1) && !this.checkProjectId(val.projectCode)) {
            disableCondition = false;
        } else {
            disableCondition = true;
        }

        this.setState({
            disabled: disableCondition,
            worklog: _worklog,
            unSelectRow: true,
            rowId: val.id
        });

        //check special leave
        let _isSpecialProject = '';
        this.state.dataProject.forEach(function(item){
            if (parseInt(item.id) === parseInt(val.projectId)) {
                return _isSpecialProject = item.projectName
            }
        });

        this.setState({
            isSpecialProject: _isSpecialProject
        });
    }

    // SortBy Worklog
    sortBy = async (val) => {
        await this.setState(prevState => ({
            paramList: {
                ...prevState.paramList,
                sortBy: val
            }
        }));

        return this.props.getWorklogList(this.state.paramList);
    }

    // Check validate form
    checkValidate = () => {
        let isValidate = false;
        let _formError = {};
        const { worklog } = this.state;

        (worklog.projectId === '') ? _formError['projectId'] = 'message.300' : _formError['projectId'] = '';
        (worklog.normalTime === '') ? _formError['normalTime'] = 'message.400' : _formError['normalTime'] = '';

        if (worklog.normalTime !== '') {
            if (isNaN(worklog.normalTime.replace(',','.')) || !functionCommon.validateDecimal(worklog.normalTime)) {
                _formError['normalTime'] = 'message.400';
            } else if (parseFloat(worklog.normalTime.replace(',','.')) <= 0) {
                _formError['normalTime'] = 'message.407';
            }
        }

        for (let i = 1; i <= 3; i++) {    
            if (worklog['overtime-' + i] !== '') {
                if (isNaN(worklog['overtime-'+ i].replace(',','.')) || !functionCommon.validateDecimal(worklog['overtime-' + i])) {
                    _formError['overtime-' + i] = 'message.404';
                } else if (parseFloat(worklog['overtime-' + i].replace(',','.')) <= 0) {
                    _formError['overtime-' + i] = 'message.408';
                }
            }
        }       

        for (let i = 1; i <= 3; i++) {  
            if ((worklog['overtime-' + i] !== '')
                && (worklog.normalTime !== '')
                && functionCommon.validateDecimal(worklog['overtime-' + i])
                && functionCommon.validateDecimal(worklog.normalTime)) {
                if (parseFloat(worklog.normalTime.replace(',','.')) > 0 && parseFloat(worklog['overtime-' + i].replace(',','.')) > 0) {
                    if (parseFloat(worklog['overtime-' + i].replace(',','.')) 
                        > parseFloat(worklog.normalTime.replace(',','.'))) {
                        _formError['overtime-' + i] = 'message.401';
                    }
                }
            }
        }
        
        let totalOT = 0;
        for (let i = 1; i <= 3; i++) {
            totalOT += Number(worklog['overtime-' + i].replace(',','.'));
        }

        if (parseFloat(worklog.normalTime.replace(',','.')) > 0 && totalOT > parseFloat(worklog.normalTime.replace(',','.'))) {
            if ((Number(worklog['overtime-1'].replace(',','.')) > 0) && (worklog['overtime-2'] === '') && (worklog['overtime-3'] === '')) {
                _formError['normalTime'] = '';
            } else if ((Number(worklog['overtime-2'].replace(',','.')) > 0) && (worklog['overtime-1'] === '') && (worklog['overtime-3'] === '')) {
                _formError['normalTime'] = ''; 
            } else if ((Number(worklog['overtime-3'].replace(',','.')) > 0) && (worklog['overtime-1'] === '') && (worklog['overtime-2'] === '')) {
                _formError['normalTime'] = '';
            } else {
                _formError['normalTime'] = 'message.410';
            }
        }

        for (let i = 1; i <= 3; i++) {  
            if ((worklog['overtime-' + i] !== '') && (worklog['overtimeType-' + i] === '')) {
                _formError['overtimeType-' + i] = 'message.403';
            } else if ((worklog['overtime-' + i] === '') && (worklog['overtimeType-' + i] !== '')) {
                _formError['overtime-' + i] = 'message.404';
            }
        }

        if ((worklog.businessFrom !== '') && (worklog.businessTo === '')) {
            _formError['businessFrom'] = 'message.406';
        } else if ((worklog.businessFrom === '') && (worklog.businessTo !== '')) {
            _formError['businessFrom'] = 'message.405';
        } else if ((worklog.businessFrom !== '') && (worklog.businessTo !== '')) {            
            if (worklog.businessTo.replace(":","") <= worklog.businessFrom.replace(":","")) {
                _formError['businessFrom'] = 'message.402';
            } else {
                _formError['businessFrom'] = '';
            }
        }      

        if (parseFloat(worklog.normalTime.replace(',','.')) <= 0) {            
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((parseFloat(worklog['overtime-1'].replace(',','.')) <= 0) 
            || (parseFloat(worklog['overtime-2'].replace(',','.')) <= 0) 
            || (parseFloat(worklog['overtime-3'].replace(',','.')) <= 0)) {            
            isValidate = false;
            this.isNotValid(_formError);
        } else if (worklog.projectId === '') {            
            isValidate = false;
            this.isNotValid(_formError);
        } else if (worklog.normalTime === '') {            
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklog['overtime-1'] !== '' && worklog['overtimeType-1'] === '')
            || (worklog['overtime-1'] === '' && worklog['overtimeType-1'] !== '')) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklog['overtime-1'] !== '' && worklog.normalTime !== '')
            && (parseFloat(worklog['overtime-1'].replace(',','.')) > parseFloat(worklog.normalTime.replace(',','.')))) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklog['overtime-2'] !== '' && worklog['overtimeType-2'] === '')
            || (worklog['overtime-2'] === '' && worklog['overtimeType-2'] !== '')) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklog['overtime-2'] !== '' && worklog.normalTime !== '')
            && (parseFloat(worklog['overtime-2'].replace(',','.')) > parseFloat(worklog.normalTime.replace(',','.')))) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklog['overtime-3'] !== '' && worklog['overtimeType-3'] === '')
            || (worklog['overtime-3'] === '' && worklog['overtimeType-3'] !== '')) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklog['overtime-3'] !== '' && worklog.normalTime !== '')
            && (parseFloat(worklog['overtime-3'].replace(',','.')) > parseFloat(worklog.normalTime.replace(',','.')))) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if (parseFloat(worklog.normalTime.replace(',','.')) > 0 && totalOT > parseFloat(worklog.normalTime.replace(',','.'))) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if (worklog.normalTime !== '' && !functionCommon.validateDecimal(worklog.normalTime)
            || worklog['overtime-1'] !== '' && !functionCommon.validateDecimal(worklog['overtime-1'])) {
            this.isNotValid(_formError);
        } else if (worklog.normalTime !== '' && !functionCommon.validateDecimal(worklog.normalTime)
            || worklog['overtime-2'] !== '' && !functionCommon.validateDecimal(worklog['overtime-2'])) {
            this.isNotValid(_formError);
        } else if (worklog.normalTime !== '' && !functionCommon.validateDecimal(worklog.normalTime)
            || worklog['overtime-3'] !== '' && !functionCommon.validateDecimal(worklog['overtime-3'])) {
            this.isNotValid(_formError);
        } else if ((worklog.businessFrom !== '' && worklog.businessTo === '')
            || (worklog.businessFrom === '' && worklog.businessTo !== '')) {
            isValidate = false;
            this.isNotValid(_formError);
        } else if ((worklog.businessFrom !== '' && worklog.businessTo !== '')
            && (worklog.businessTo.replace(":","") <= worklog.businessFrom.replace(":",""))) {
            isValidate = false;
            this.isNotValid(_formError);
        } else {
            isValidate = true;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: {}
                }
            }));
        }
        return isValidate;
    }

    isNotValid = (_formError) => {
        this.setState(prevState => ({
            inputSubmit: {
                ...prevState.inputSubmit,
                formError: _formError
            }
        }));
    }

    checkProjectId = (val) => {
        let id = null;
        this.state.dataProject.map(item => {
            if (val === item.projectCode) {
                id = true;
            }
        });
        return id;
    }

    fixDecimal = (val) => {
        return (functionCommon.isDecimal(val)) 
        ? Number(parseFloat(val).toFixed(2)) 
        : val
    }

    // Handle on change autoComplete
    changeAutoComplete = evt => {
        const name = evt._name;
        const value = evt._value;
        this.setState(prevState => ({
            worklog: {
                ...prevState.worklog,
                [name]: value
            }
        }));
        this.setState(prevState => ({
            inputSubmit: {
                ...prevState.inputSubmit,
                formError: {
                    ...prevState.inputSubmit.formError,
                    [name]: ""
                }
            }
        }));        

        if (name === "projectId") {
            //check special leave
            let _isSpecialProject = '';
            this.state.dataProject.forEach(function(item){
                if (parseInt(item.id) === parseInt(value)) {
                    return _isSpecialProject = item.projectName
                }
            });

            this.setState({
                isSpecialProject: _isSpecialProject
            });
        }
    }

    render() {
        const { t } = this.props;
        const { errorCode, successCode, totalOtDay, totalWorkingHourDay, hasWorklog, errorCodeForm } = this.state;
        return (
            <div className="working-hour-wrap">
                <h2 className="page-heading">
                    <span onClick={() => setTimeout(function() { window.location = '/update-working-hour' }, 500)}>{t("navigation.engineerHourRecord")}</span>
                    / <span onClick={() => setTimeout(function() { window.location.reload() }, 500)}>{t("navigation.updateWorkingHour")}</span></h2>
                <div className="list-actions">
                    <Button primary disabled={this.state.isWaiting} onClick={() => this.addWorklog()}>
                        <Icon name='add circle' />{t('button.add')}
                    </Button>
                    <Button primary disabled={(!this.state.isWaiting && this.state.disabled) ? false : true} 
                        onClick={() => this.updateWorklog()} className="update-btn">
                        <Icon name='edit' />{t('button.update')}
                    </Button>
                    <Button primary disabled={(!this.state.isWaiting && this.state.disabled) ? false : true} 
                        onClick={() => this.deleteWorklog()} className="delete-btn">
                        <Icon name='trash alternate outline' />{t('button.delete')}
                    </Button>
                    <Button primary onClick={() => setTimeout(function() { window.location = '/inquiry-data' }, 500)}>
                        <Icon name='file alternate' />{t('button.detailInfo')}
                    </Button>
                    <Button disabled={this.state.isWaiting || (!this.state.isWaiting && hasWorklog === 0) 
                                    || (this.state.data.length === 0)} onClick={() => this.getApproval()}>
                        <Icon name='send' />{t('button.getApproval')}
                    </Button>
                </div>
                <WorkingHourForm
                    worklogData={this.state.worklog}
                    dataProject={this.state.dataProject}
                    dataApprover={this.state.dataApprover}
                    totalOtOfMonth={this.fixDecimal(this.state.totalOtOfMonth)}
                    changeWorkLog={(input) => this.changeWorkLog(input)}
                    changeBusinessTime={(input, value) => this.changeBusinessTime(input, value)}
                    businessFrom={this.state.worklog.businessFrom}
                    businessTo={this.state.worklog.businessTo}
                    searchWorklog={(date) => this.searchWorklog(date)}
                    isError={this.state.inputSubmit.formError}
                    isSpecialProject={this.state.isSpecialProject}
                    changeAutoComplete={input => this.changeAutoComplete(input)}
                />
                {successCode ? (
                    <div className="success-message list-error-message">
                        {t("message." + successCode)}
                    </div>
                ) : (
                        ""
                    )}
                {errorCode ? (
                    <div className="error-message list-error-message">
                        {(errorCode == "010") ? t("message.019") : t("message." + errorCode)}
                    </div>
                ) : (
                        ""
                    )}
                <ProjectTable
                    tableStructure={this.state.tableStructure}
                    dataList={this.state.data}
                    totalOtDay={this.fixDecimal(totalOtDay) || ''}
                    totalWorkingHourDay={this.fixDecimal(totalWorkingHourDay) || ''}
                    onRowClick={(val) => this.onRowClick(val)}
                    defaultSort={this.state.paramList.sortBy}
                    sortBy={(val) => this.sortBy(val)}
                    unSelectRow={this.state.unSelectRow}
                    isTotal={this.state.isTotal}
                    isWorkingHourPage
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ...state,
})

const mapDispatchToProps = dispatch => ({
    getWorklogList: (opt) => dispatch(getWorklogList(opt)),
    addWorklog: (opt) => dispatch(addWorklog(opt)),
    updateWorklog: (opt) => dispatch(updateWorklog(opt)),
    deleteWorklog: (opt) => dispatch(deleteWorklog(opt)),
    getApproval: (opt) => dispatch(getApproval(opt))
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(WorkingHour);
